import { authStore, useAuth } from '@/lib/auth/auth';
import type { MeResult, SetPasswordRequest } from '@/lib/api/apiTypes';
import { useMutation } from '@tanstack/react-query';

export function useSetPassword() {
  const request = useAuth((state) => state.request);

  return useMutation({
    mutationFn: (payload: SetPasswordRequest) =>
      request<MeResult>('/me/password/set', {
        method: 'POST',
        body: JSON.stringify(payload),
      }),
    onSuccess: (me) => {
      authStore.setState((state) =>
        state.session
          ? {
              ...state,
              session: {
                ...state.session,
                me,
              },
            }
          : state
      );
    },
  });
}
